import {AppThunk, PlanActions, PlanData, PlanInput, PlanType} from "../types";
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { UserState } from '../types';
import { filterArrVals } from "../utils/plan";
import { dispatch } from "rxjs/internal/observable/pairs";
import { getFailurePayloadOf } from "../utils/redux";
import { storage } from "../firebase";

const baseApiURL =
  process.env.REACT_APP_NODE_ENV === 'production'
    ? 'https://finauta-internal-python.herokuapp.com'
    : 'http://127.0.0.1:8000';

export const generateRetirementPlan: AppThunk = (values, user) => {
  return async (_dispatch, getState) => {
    try {
      const planId = values.planId ?? uuidv4();
      const userId = (getState().user as unknown as UserState).user?.id;
      const data = new FormData();
      let key: keyof typeof values;
      for (key in values) {
        if (values[key] !== null && values[key] !== undefined && values[key] !== "") {
          if (key === 'mod_40_scenarios' || key === 'investment_scenarios') {
            data.set(key, values[key].filter((v: number) => filterArrVals(v)).join(','));
          } else {
            data.set(key, values[key]);
          }
        }
      }
      data.set('has_partner', ((values.civil_status === 'Casado') as unknown as string));
      data.set('plan_id', planId);
      data.set('user_id', userId!);
      if (user && user?.flavour) {
        data.set('flavour', user.flavour);
      } else if (values.plan_type == PlanType.DIAGNOSTIC) {
        data.set('flavour', 'finauta_study');
      } else {
        data.set('flavour', 'finauta');
      }
      await axios
      .post(`${baseApiURL}/generateplan/`, data)
    } catch(e) {
      console.error(e.request.response)
    }
  }
}

export const downloadPlan: AppThunk = (plan: PlanData, user_name: string, plan_type: string) => {
  return async (dispatch) => {
    try {
      const url = await storage.ref(plan.ref).getDownloadURL();
      const res = await axios({ url: url, method: 'GET', responseType: 'blob' });
      const download_url = window.URL.createObjectURL(res.data);
      const link = document.createElement('a');
      link.href = download_url;
      if (plan_type ===  PlanType.DIAGNOSTIC) {
        link.setAttribute('download', `${plan.type === "blocked" ? "[bloqueado] " : ""}Diagnóstico - ${user_name}`);
      } else if (plan_type === PlanType.STUDY) {
        link.setAttribute('download', `${plan.type === "blocked" ? "[bloqueado] " : ""}Estudio de pensión - ${user_name}`);
      } else {
        const special_id = (plan_type === PlanType.RETROACTIVE || plan_type === PlanType.ORGINAL_RETROACTIVE) ? "retroactivo " : ""
        link.setAttribute('download', `${plan.type === "blocked" ? "[bloqueado] " : ""}Plan de pensión ${special_id}- ${user_name}`);
      }

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (e) {
      console.log(e);
      return dispatch(getFailurePayloadOf(PlanActions.DOWNLOAD_PLAN, e));
    }
  }
}

